<div mat-dialog-title class="bg-primary mat-elevation-z5">
  {{ getTitle() }}
  <button mat-icon-button class="pull-right" (click)="cancel()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content>
  <form [formGroup]="userDetails" autocomplete="off">
    <mat-tab-group class="vertical-tabs">
      <mat-tab label="Basic">
        <div class="form-field-outer flex-col">
          <!-- Username -->
          <mat-form-field class="w-100">
            <input
              matInput
              placeholder="Username"
              type="email"
              name="userName"
              formControlName="userName"
              email
              required
              />
              @if (
                (userDetails.dirty || userDetails.touched) &&
                userName.errors?.required
                ) {
                <mat-error
                  >
                  Required
                </mat-error>
              }
              @if (
                (userDetails.dirty || userDetails.touched) &&
                userName.errors?.email
                ) {
                <mat-error
                  >
                  Incorrect username
                </mat-error>
              }
            </mat-form-field>
            <!-- First Name -->
            <mat-form-field class="w-100">
              <input
                matInput
                placeholder="First Name"
                name="firstName"
                formControlName="firstName"
                data-z-validate
                />
              </mat-form-field>
              <!-- Last Name -->
              <mat-form-field class="w-100">
                <input
                  matInput
                  placeholder="Last Name"
                  name="lastName"
                  formControlName="lastName"
                  data-z-validate
                  />
                </mat-form-field>
                <!-- Role multi-select -->
                <mat-form-field class="w-100">
                  <mat-select
                    placeholder="Roles"
                    name="roles"
                    [compareWith]="compareRoles"
                    [errorStateMatcher]="errorMatch"
                    formControlName="roles"
                    required
                    multiple
                    >
                    <mat-select-trigger>
                      {{ roles.value?.length > 0 ? roles.value[0].name : "" }}
                      @if (roles.value?.length > 1) {
                        <span
                          class="additional-selection"
                          >
                          (+{{ roles.value.length - 1 }}
                          {{ roles.value?.length === 2 ? "other" : "others" }})
                        </span>
                      }
                    </mat-select-trigger>
                    @for (role of roles$ | async; track role) {
                      <mat-option [value]="role">
                        {{ role.name }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (roles.errors?.required) {
                    <mat-error> Required </mat-error>
                  }
                </mat-form-field>
                <!-- Retailer -->
                <mat-form-field class="w-100">
                  <mat-select
                    placeholder="Retailer"
                    name="retailerId"
                    formControlName="retailerId"
                    [required]="isRetailerRequired()"
                    >
                    <mat-option>Select a retailer</mat-option>
                    @for (retailer of retailers$ | async; track retailer) {
                      <mat-option
                        [value]="retailer.id"
                        >
                        {{ retailer.name }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <!-- <mat-form-field class="w-100" *ngIf="!hideCurrentPassword">
                <input type="password" matInput placeholder="Current Password"
                  name="currentPassword"
                  [formControl]="currentPassword"
                  data-z-validate>
                </mat-form-field> -->
                @if (isNew) {
                  <mat-form-field class="w-100">
                    <input
                      type="password"
                      matInput
                      placeholder="Password"
                      name="password"
                      formControlName="password"
                      minlength="8"
                      [required]="isNew"
                      />
                      @if (
                        (userDetails.dirty || userDetails.touched) &&
                        password.errors?.required
                        ) {
                        <mat-error
                          >
                          Required
                        </mat-error>
                      }
                      @if (
                        (userDetails.dirty || userDetails.touched) &&
                        password.errors?.minlength
                        ) {
                        <mat-error
                          >
                          Incorrect password length
                        </mat-error>
                      }
                      @if (
                        (userDetails.dirty || userDetails.touched) &&
                        password.errors?.hasNumber
                        ) {
                        <mat-error
                          >
                          At least one digit character required
                        </mat-error>
                      }
                      @if (
                        (userDetails.dirty || userDetails.touched) &&
                        password.errors?.hasCapitalCase
                        ) {
                        <mat-error
                          >
                          At least one upper case character required
                        </mat-error>
                      }
                      @if (
                        (userDetails.dirty || userDetails.touched) &&
                        password.errors?.hasSpecial
                        ) {
                        <mat-error
                          >
                          At least one special character required
                        </mat-error>
                      }
                    </mat-form-field>
                  }
                  @if (isNew) {
                    <mat-form-field class="w-100">
                      <input
                        type="password"
                        matInput
                        placeholder="Confirm Password"
                        name="confirmPassword"
                        formControlName="confirmPassword"
                        [required]="isNew"
                        />
                        @if (password.dirty && confirmPassword.errors?.required) {
                          <mat-error
                            >
                            Required
                          </mat-error>
                        }
                        @if (password.dirty && confirmPassword.errors?.mustMatch) {
                          <mat-error
                            >
                            Passwords do not match
                          </mat-error>
                        }
                      </mat-form-field>
                    }
                  </div>
                </mat-tab>

                <mat-tab label="Change Password">
                  <div class="form-field-outer flex-col">
                    <mat-form-field class="w-100">
                      <input
                        type="password"
                        matInput
                        placeholder="Password"
                        name="changePassword"
                        formControlName="changePassword"
                        minlength="8"
                        />
                        <!-- <mat-error *ngIf="changePassword.errors?.required">
                        Required
                      </mat-error> -->
                      @if (changePassword.errors?.minlength) {
                        <mat-error>
                          Incorrect password length
                        </mat-error>
                      }
                      @if (changePassword.errors?.hasNumber) {
                        <mat-error>
                          At least one digit character required
                        </mat-error>
                      }
                      @if (changePassword.errors?.hasCapitalCase) {
                        <mat-error>
                          At least one upper case character required
                        </mat-error>
                      }
                      @if (changePassword.errors?.hasSpecial) {
                        <mat-error>
                          At least one special character required
                        </mat-error>
                      }
                    </mat-form-field>
                    <mat-form-field class="w-100">
                      <input
                        type="password"
                        matInput
                        placeholder="Confirm Password"
                        name="confirmChangePassword"
                        formControlName="confirmChangePassword"
                        [required]="changePassword.dirty"
                        />
                        @if (
                          changePassword.dirty && confirmChangePassword.errors?.required
                          ) {
                          <mat-error
                            >
                            Required
                          </mat-error>
                        }
                        @if (
                          changePassword.dirty && confirmChangePassword.errors?.mustMatch
                          ) {
                          <mat-error
                            >
                            Passwords do not match
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  </mat-tab>
                </mat-tab-group>
              </form>
            </div>
            <div mat-dialog-actions class="w-100 user-details-actions-flex">
              <div class="error-message user-details-actions-error">
                <span [innerHTML]="errorMessage"></span>
              </div>
              <div class="user-details-actions-spacer">&nbsp;</div>
              <div class="user-details-actions-buttons">
                <div class="footer-buttons">
                  <button mat-button color="warn" (click)="cancel()">Cancel</button>
                  <button
                    mat-raised-button
                    color="primary"
                    (click)="save()"
                    [disabled]="userDetails.invalid"
                    >
                    @if (loading) {
                      <mat-icon>
                        <mat-spinner color="warn" diameter="20" />
                      </mat-icon>
                    }
                    Save
                  </button>
                </div>
              </div>
            </div>
